import {
  CHANGE_AUTH_PHONE,
  SHOW_AUTH_ALERT,
  HIDE_AUTH_ALERT,
  VERIFICATION_CODE_SENT,
  CHANGE_AUTH_CODE,
  SUBMIT_AUTH_CODE,
  USER_IS_AUTHENTICATED,
  AUTH_CODE_ERROR,
  LOGOUT,
  SET_USER_ID,
  SHOULD_LOGIN,
  SHOW_PHONE_ALERT,
  HIDE_PHONE_ALERT,
  ASYNC_START,
  CHANGE_PROFILE_INPUT,
  GET_PROFILE,
  STORE_PROFILE,
  PROFILE_LAST_NAME_ERROR,
  PROFILE_NAME_ERROR,
  ASYNC_VERIFY_LOGIN,
  START_STORE_PROFILE,
  END_STORE_PROFILE,
  DISABLE_SHOULD_LOGIN,
  CHANGE_REFERRAL,
  DISABLE_REFERRAL,
  CHANGE_UTM_SOURCE,
  CHANGE_CALL_CENTER_PHONE_NUMBER,
} from "../actions/actionsTypes";

const initialState = {
  authenticated: false,
  ErrorAlert: false,
  authCode: "",
};

// todo: resolve next line
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case ASYNC_START:
      return { ...state, inProgress: true };

    case SHOW_AUTH_ALERT:
      return { ...state, authentication: true };

    case HIDE_AUTH_ALERT:
      return { ...state, authentication: false };

    case CHANGE_AUTH_PHONE:
      var correctPhone = /^(\+98|98|0|\+90|90)?9(\d{9}|\d{11})$/.test(
        action.value
      );
      // console.log(correctPhone);
      return { ...state, authPhone: action.value, correctPhone };

    case VERIFICATION_CODE_SENT:
      return {
        ...state,
        inProgress: false,
        phoneAlert: false,
        verifyAlert: true,
      };

    case CHANGE_AUTH_CODE:
      return { ...state, authCode: action.value, authCodeError: false };

    case AUTH_CODE_ERROR:
      return { ...state, authCodeError: true, authCode: "" };

    case SUBMIT_AUTH_CODE:
      if (action.data.name)
        return {
          ...state,
          inProgress: false,
          authenticated: true,
          authentication: false,
          verifyAlert: false,
        };
      else
        return {
          ...state,
          inProgress: false,
          authenticated: true,
          profile: action.data,
          showNamePopUp: true,
          verifyAlert: false,
        };

    case USER_IS_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        shouldLogin: false,
        authentication: false,
      };

    case LOGOUT:
      return {
        ...state,
        authenticated: false,
        authCode: "",
        profile: undefined,
      };

    case SET_USER_ID:
      return { ...state, userId: action.value };

    case SHOULD_LOGIN:
      return {
        ...state,
        shouldLogin: true,
        authentication: true,
        phoneAlert: true,
      };

    case SHOW_PHONE_ALERT:
      return { ...state, phoneAlert: true, phoneAlertMessage: action.message };

    case HIDE_PHONE_ALERT:
      return { ...state, phoneAlert: false, phoneAlertMessage: "" };

    case GET_PROFILE:
      return {
        ...state,
        profile: {
          ...action.profile,
          name: action.profile.name,
          family: action.profile.family,
        },
      };

    case CHANGE_PROFILE_INPUT:
      const correctEmail =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          action.value
        );

      if (action.name === "name")
        return {
          ...state,
          nameError: false,
          profile: { ...state.profile, [action.name]: action.value },
        };
      else if (action.name === "family")
        return {
          ...state,
          lastNameError: false,
          profile: { ...state.profile, [action.name]: action.value },
        };
      else if (action.name === "email" && action.value !== "")
        return {
          ...state,
          [action.name + "Error"]: !correctEmail,
          profile: { ...state.profile, [action.name]: action.value },
        };
      return {
        ...state,
        [action.name + "Error"]: false,
        profile: { ...state.profile, [action.name]: action.value },
      };

    case STORE_PROFILE:
      return { ...state, inProgress: false, authentication: false };

    case PROFILE_NAME_ERROR:
      return { ...state, nameError: true };

    case PROFILE_LAST_NAME_ERROR:
      return { ...state, lastNameError: true };

    case ASYNC_VERIFY_LOGIN:
      return { ...state, asyncVerifyLogin: action.value };

    case START_STORE_PROFILE:
      return { ...state, storingProfile: true };

    case END_STORE_PROFILE:
      return { ...state, storingProfile: false };

    case DISABLE_SHOULD_LOGIN:
      return { ...state, shouldLogin: false };

    case CHANGE_REFERRAL:
      return {
        ...state,
        profile: { ...state.profile, share_code: action.value },
      };

    case DISABLE_REFERRAL:
      return { ...state, disableReferral: true };

    case CHANGE_UTM_SOURCE:
      return { ...state, utm_source: action.value };

    case CHANGE_CALL_CENTER_PHONE_NUMBER:
      return { ...state, callCenterPhoneNumber: action.value };

    default:
      return state;
  }
};
